import styled, {DefaultTheme} from 'styled-components';
import {Card, Typography, Button, Input} from 'antd';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const dark = (props: { theme?: DefaultTheme }, darkVal: string, lightVal: string): string =>
  props.theme?.mode === 'dark' ? darkVal : lightVal;

export const ProfilePageWrapper = styled.div`
  padding: 24px 16px;
  max-width: 720px;
  margin: 0 auto;
`;

export const ProfilePageTitle = styled(Typography.Title)`
  margin-bottom: 24px !important;
  color: ${(p) => dark(p, '#f7fafc', '#1a202c')} !important;
  font-weight: 600 !important;
  letter-spacing: -0.02em;
`;

export const ProfileCard = styled(Card)`
  border-radius: 12px;
  border: 1px solid ${(p) => dark(p, '#4a5568', '#e2e8f0')};
  background: ${(p) => dark(p, '#1a202c', '#ffffff')};
  box-shadow: ${(p) =>
    dark(p, '0 4px 6px -1px rgba(0, 0, 0, 0.2)', '0 1px 3px 0 rgba(0, 0, 0, 0.08)')};

  .ant-card-body {
    padding: 32px;
  }
`;

export const AvatarRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
`;

export const AvatarWrapper = styled.div`
  .ant-avatar {
    background: ${(p) => dark(p, '#4a5568', '#63b3ed')};
    color: ${(p) => dark(p, '#e2e8f0', '#fff')};
  }
`;

export const EditProfileButton = styled(Button)`
  border-radius: 8px;
  font-weight: 500;
  &.ant-btn-default {
    border-color: ${(p) => dark(p, '#4a5568', '#cbd5e0')};
    color: ${(p) => dark(p, '#e2e8f0', '#2d3748')};
    background: ${(p) => dark(p, '#2d3748', '#fff')};
  }
  &.ant-btn-default:hover {
    border-color: ${(p) => dark(p, '#63b3ed', '#3182ce')};
    color: ${(p) => dark(p, '#63b3ed', '#3182ce')};
  }
`;

export const UserInfoBlock = styled.div`
  margin-bottom: 24px;
`;

export const ProfileName = styled(Typography.Title)`
  margin-bottom: 4px !important;
  color: ${(p) => dark(p, '#f7fafc', '#1a202c')} !important;
  font-weight: 600 !important;
`;

export const ProfileRoleBadge = styled(Typography.Text)`
  display: block;
  margin-bottom: 4px;
  color: #3182ce;
  font-size: 14px;
  font-weight: 500;
`;

export const ProfileAddress = styled(Typography.Text)`
  display: block;
  color: ${(p) => dark(p, '#a0aec0', '#718096')};
  font-size: 14px;
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DetailLabel = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: ${(p) => dark(p, '#a0aec0', '#718096')};
`;

export const DetailInput = styled(Input)`
  border-radius: 8px;
  background: ${(p) => dark(p, '#2d3748', '#edf2f7')} !important;
  border-color: ${(p) => dark(p, '#4a5568', '#e2e8f0')} !important;
  color: ${(p) => dark(p, '#f7fafc', '#2d3748')} !important;
  &:disabled {
    cursor: default;
    opacity: 1;
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
`;

export const CardSpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  padding: 24px;
`;
